<template>
  <div id="app">
    <div id="content">
      <MainComponent/>
    </div>
  </div>
</template>

<script>
import MainComponent from './components/mainComponent.vue'
export default {
  name: 'App',
  components: {
    MainComponent
  }
}
</script>

<style>
#head{
  display: flex;
  justify-content: center;
}

</style>
